module.exports = __webpack_public_path__ + "static/media/access-to-appstore-sevice.5629fc48.jpg";